// test1619
(1619 && 0);
